import { Component, OnInit, ViewChild } from '@angular/core';
import { CausalNoAceptacion, ClienteRediferidos, FacturaRediferido, Perfil, SimulacionCuota} from '../../utils/perfil.model';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { MatPaginator } from '@angular/material/paginator';
import { switchMap, tap, catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { RediferidosService } from '../../services/rediferidos.service';
import { DetalleArmoticacionModalComponent } from '../modals/detalle-armoticacion-modal/detalle-armoticacion-modal.component';


@Component({
  selector: 'app-simulacion',
  templateUrl: './simulacion.component.html',
  styleUrls: ['./simulacion.component.scss']
})
export class SimulacionComponent implements OnInit {
perfiles: Perfil[] = [];
  perfilSeleccionado: Perfil | null = null;

  // Cliente
  documento = '';
  cliente?: ClienteRediferidos;

  cargandoCliente = false;
  clienteNoEncontrado = false;
  cargandoSimulacion = false;

  simulaciones: SimulacionCuota[] = [];
  facturas: FacturaRediferido[] = [];

  dataSource = new MatTableDataSource<any>([]);
  @ViewChild('simulacionPaginator', { static: false }) paginator!: MatPaginator;

  aplicandoNoAceptacion = false;
  noAceptacionExitosa = false;

  mensajeNoAceptacion = '';

  causalSeleccionada = '';

  causales: CausalNoAceptacion[] = [];
  cargandoCausales = false;

  aplicando = false;
  aplicadoExitoso = false;
  mensajeAplicado = '';

  showAllFacturas = false;

  displayedColumns: string[] = [
    'numeroCuotas',
    'capital',
    'intereses',
    'seguro',
    'seguroMillon',
    'valorCuota',
    'tasa',
    'acciones'
  ];

  constructor(
    private rediferidosService: RediferidosService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    console.log("Cargando");
    
    this.cargarPerfiles();
  }


  get habilitarBuscar(): boolean {
    return !!this.perfilSeleccionado && !!this.documento;
  }

  get displayedFacturas(): FacturaRediferido[] {
    return this.showAllFacturas ? this.facturas : this.facturas.slice(0, 3);
  }

  get totalValorFacturas(): number {
    return this.facturas.reduce((sum, f) => sum + f.valor, 0);
  }

  get totalCuotasPendientes(): number {
    return this.facturas.reduce((sum, f) => sum + f.cuotasPendientes, 0);
  }

  cargarPerfiles(): void {
    this.rediferidosService.buscarPerfilesActivos().subscribe({
      next: perfiles => (this.perfiles = perfiles),
      error: () => console.error('Error cargando perfiles')
    });
  }

  onPerfilChange(perfil: Perfil): void {
    this.perfilSeleccionado = perfil;
  }

  buscarCliente(): void {
    if (!this.habilitarBuscar) return;

    this.resetEstadoBusqueda();
    this.cargandoCliente = true;

    this.rediferidosService
      .buscarCliente(this.documento)
      .pipe(
        tap(cliente => {
          this.cliente = cliente;
        }),
        switchMap(cliente => this.rediferidosService.buscarFactura(cliente)),
        tap(facturas => {
          this.facturas = facturas;
        }),
        finalize(() => {
          this.cargandoCliente = false;
        }),
        catchError(error => {
          console.error('Error en busqueda cliente/facturas', error);
          this.cliente = undefined;
          this.facturas = [];
          this.clienteNoEncontrado = true;
          return of([]);
        })
      )
      .subscribe(() => {
        this.simularCuotas();
        this.cargarCausales();
      });
  }

  private resetEstadoBusqueda(): void {
    this.cliente = undefined;
    this.facturas = [];
    this.simulaciones = [];
    this.dataSource.data = [];
    this.clienteNoEncontrado = false;
    this.showAllFacturas = false;
  }

  toggleMostrarFacturas(): void {
    this.showAllFacturas = !this.showAllFacturas;
  }

  trackByFactura(index: number, item: FacturaRediferido): string {
    return item.factura + '_' + index;
  }

  simularCuotas(): void {
    if (
      !this.perfilSeleccionado ||
      !this.perfilSeleccionado.rediferidosPerfilDet?.length ||
      !this.cliente
    ) {
      return;
    }

    this.cargandoSimulacion = true;
    this.simulaciones = [];
    this.dataSource.data = [];

    let pendientes = this.perfilSeleccionado.rediferidosPerfilDet.length;

    for (const det of this.perfilSeleccionado.rediferidosPerfilDet) {
      this.rediferidosService
        .simularCuota(this.cliente!, det.cuotaIni, this.perfilSeleccionado.tasa)
        .subscribe({
          next: resp => {
            this.simulaciones.push(resp);

            this.dataSource.data = [
              ...this.dataSource.data,
              {
                numeroCuotas: resp.cuotas,
                capital: resp.totalCapital,
                intereses: resp.totalInteres,
                seguro: resp.totalSeguro,
                seguroMillon: resp.tarifaSeguroMillon,
                valorCuota: resp.valorCuota,
                tasa: resp.tasaNominalMensual,
                simulacion: resp
              }
            ];

            // Ordenar por numero de cuotas
            this.dataSource.data = this.dataSource.data.sort(
              (a: any, b: any) => a.numeroCuotas - b.numeroCuotas
            );

            pendientes--;

            if (pendientes === 0) {
              this.cargandoSimulacion = false;
              setTimeout(() => {
                this.dataSource.paginator = this.paginator;
              });
            }
          },
          error: () => {
            pendientes--;
            if (pendientes === 0) {
              this.cargandoSimulacion = false;
            }
          }
        });
    }
  }

  verDetalles(simulacion: SimulacionCuota): void {
    this.dialog.open(DetalleArmoticacionModalComponent, {
      width: '900px',
      data: {
        detalle: simulacion.detalleAmortizacion
      }
    });
  }

  aplicarSimulacion(simulacion: SimulacionCuota): void {
    if (!this.cliente) return;

    if (!confirm('Esta seguro de aplicar esta simulacion a cartera?')) {
      return;
    }

    this.aplicando = true;
    this.aplicadoExitoso = false;
    this.mensajeAplicado = '';

    // Ocultar tabla
    this.dataSource.data = [];

    const body = {
      c_emp: this.rediferidosService.getCompany(),
      c_agr: this.cliente.cAgr,
      t_cre: this.cliente.tCre,
      cue: this.cliente.cue,
      n_ide: this.cliente.nIde,
      cuotas: simulacion.cuotas,
      tasa: simulacion.tasaNominalMensual,
      seguro: simulacion.totalSeguro,
      capital: simulacion.totalCapital,
      age_est: this.cliente.ageEst,
      est_cre: this.cliente.estCred
    };

    this.rediferidosService.aplicarRediferido(body).subscribe({
      next: resp => {
        if (resp.success) {
          this.aplicadoExitoso = true;
          this.mensajeAplicado = resp.message || 'Aplicado a cartera exitosamente';
          setTimeout(() => this.resetTodo(), 2500);
        }
      },
      error: err => {
        console.error('Error aplicando rediferido', err);
        this.aplicando = false;
      },
      complete: () => {
        this.aplicando = false;
      }
    });
  }

  cargarCausales(): void {
    if (this.causales.length > 0) return;

    this.cargandoCausales = true;

    this.rediferidosService.buscarCausales().subscribe({
      next: data => {
        this.causales = data;
      },
      error: err => {
        console.error('Error cargando causales', err);
      },
      complete: () => {
        this.cargandoCausales = false;
      }
    });
  }

  enviarNoAceptacion(): void {
    if (!this.cliente || !this.causalSeleccionada) return;

    if (!confirm('Esta seguro de aplicar la no aceptacion?')) return;

    this.aplicandoNoAceptacion = true;
    this.noAceptacionExitosa = false;

    const body = {
      n_ide: this.cliente.nIde,
      c_agr: this.cliente.cAgr,
      t_cre: this.cliente.tCre,
      cue: this.cliente.cue,
      nombre_titular: this.cliente.nombreTitular,
      total: this.cliente.total,
      saldo: this.cliente.saldo,
      cuotaActual: this.cliente.cuotaActual,
      age_est: this.cliente.ageEst,
      est_cre: this.cliente.estCred,
      saldo_venc: this.cliente.saldoVencido,
      cod_causal: this.causalSeleccionada,
      c_emp: this.rediferidosService.getCompany()
    };

    this.rediferidosService.noAceptarRediferido(body).subscribe({
      next: resp => {
        if (resp.success) {
          this.noAceptacionExitosa = true;
          this.mensajeNoAceptacion = resp.message;
        }
      },
      error: err => {
        console.error('Error no aceptacion', err);
        this.aplicandoNoAceptacion = false;
      },
      complete: () => {
        this.aplicandoNoAceptacion = false;
        setTimeout(() => this.resetTodo(), 2500);
      }
    });
  }

  resetTodo(): void {
    this.documento = '';
    this.perfilSeleccionado = null;
    this.cliente = undefined;
    this.facturas = [];
    this.simulaciones = [];
    this.dataSource.data = [];
    this.aplicadoExitoso = false;
    this.mensajeAplicado = '';
    this.clienteNoEncontrado = false;
    this.causalSeleccionada = '';
    this.noAceptacionExitosa = false;
    this.mensajeNoAceptacion = '';
    this.showAllFacturas = false;
    this.aplicando = false;
    
  }











}